define('home/views/FollowChannelPromptView',[
    'backbone-marionette',

    'remote/config',

    'core/mixins/withChannelFollowing',
    'home/mixins/withExpiration',
    'home/models/Session',
    'home/templates/followChannelPrompt',
], function (
    Marionette,

    remoteConfig,

    withChannelFollowing,
    withExpiration,
    Session,
    followChannelPromptTemplate
) {
    'use strict';

    var FollowChannelPromptView = Marionette.ItemView.extend({
        template: followChannelPromptTemplate,

        templateHelpers: function () {
            return {
                shouldShowAlert: this.session.isLoggedIn() && !this.model.primaryForum.get('isFollowing'),
            };
        },

        initialize: function () {
            this.session = Session.get();
            this.expirationKey = 'followChannelPrompt-' + this.model.get('slug');
            this.defaultViews = remoteConfig.lounge.follow_channel_prompt_views;

            this.listenTo(this.session, 'change:id', this.render);
        },

    });

    withChannelFollowing.call(FollowChannelPromptView.prototype);
    withExpiration.call(FollowChannelPromptView.prototype);

    return FollowChannelPromptView;
});

